import { initHeroWaves } from "./hero/heroWaves.js";
import { initNav } from "./components/nav.js";
import { initScrollSpy } from "./utils/scrollSpy.js";
import { initScrollProgress } from "./utils/scrollProgress.js";
import { initWorkSlider } from "./components/workSlider.js";
import { initProcessProgress } from "./components/processProgress";
import { initScrollReveal } from "./utils/scrollReveal.js";

import { initTextScramble, setHeroLogoController } from "./components/text-scramble.js";
import { initFlowfieldParticles } from "./components/flowfieldParticles.js";

function initOnDomReady() {
  // Site UI
  initNav();
  initScrollSpy();
  initScrollProgress();
  initWorkSlider();
  initProcessProgress();
  initScrollReveal();

  // Hero background
  initHeroWaves({
    onReady: () => {
      const waveBg = document.querySelector(".hero__wave-bg");
      if (waveBg) waveBg.classList.add("is-ready");
    },
  });

  // ---------------------------------------------------------------------------
  // Logo canvas: kick off the fetch immediately (network I/O, free to start now).
  // The constructor calls async init() which does:
  //   await fetch()          ← yields here, returns to us, fetch runs in background
  //   sampler.load()         ← ONE-TIME: getBBox + getPointAtLength, then cached forever
  //   initializeCanvas()     ← first sampleToCanvas() is just a transform loop over
  //                             the cached raw samples. Fast.
  //
  // The controller object is valid immediately (pendingStart handles the race if
  // text-scramble calls .start() before the SVG has loaded).
  // ---------------------------------------------------------------------------
  const logo = initFlowfieldParticles();
  setHeroLogoController(logo);

  // Text scramble orchestration.
  // Hero sequence: h1 → subtitle → tagline (sequential), then logo-reveal +
  // pixel-scramble (parallel). logo-reveal just calls logo.start() — if the SVG
  // isn't loaded yet, pendingStart queues it and it fires automatically when ready.
  initTextScramble();
}

function initOnLoad() {
  if (window.AOS) {
    AOS.init({ once: true, duration: 2000 });
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initOnDomReady, { once: true });
} else {
  initOnDomReady();
}

window.addEventListener("load", initOnLoad, { once: true });

// dev-only FPS/RAF probe
// (function rafProbe() {
//   let frames = 0;
//   let last = performance.now();
//   function tick(now) {
//     frames++;
//     if (now - last >= 1000) {
//       console.log("[rafProbe] fps ~", frames);
//       frames = 0;
//       last = now;
//     }
//     requestAnimationFrame(tick);
//   }
//   requestAnimationFrame(tick);
// })();
